import NavbarPlaceholder from "./NavbarPlaceholder";

export default NavbarPlaceholder;
